import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';
import { formatAMPM } from '../utils/constant';
import { NotificationService } from '../services/notification.service';
import { forkJoin } from 'rxjs';
import { User } from '../models/userModel';

@Component({
  selector: 'app-cross-chat',
  templateUrl: './cross-chat.component.html',
  styleUrls: ['./cross-chat.component.css'],
})
export class CrossChatComponent implements OnInit, OnDestroy {
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  chat: any[] = [];
  chatData: any;
  postChat: any[] = [];
  chatStatus: boolean = false;
  loginUser: string = '';
  loginUserName: string = '';
  newMessage: string = '';
  userName: string = '';
  postUserImage: string = '';
  userProfile: string = '';
  contactUser: string = '';
  postId: string = '';
  searchValue: string = '';
  socket: any;
  allUser: any;
  isLoading: boolean = false;
  chatType: any;
  chatId: any;
  activeTab: any = 'all';
  merchantChat: any[] = [];
  allChat: any = [];
  friends: any = [];
  friendsChat: any = [];
  cachedSearchResult: User[] = [];
  allTabsUserList: User[] = [];
  publicTabsUserList: User[]=[]
  showNewChatList: boolean = false;
  newChatUser: User[] = [];

  toggleNewChatList() {
    if (this.showNewChatList) {
      this.showNewChatList = false;
    } else {
      this.newChat();
    }
  }
  searchTerm: string = '';
  ministriesUserList: User[] = [];
  activeMessageSenderId: string = '';
  isDropdownOpen: boolean = false;
  selectedChatType: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private socketService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {
    this.postId = this.route.snapshot.queryParams['id'];
  }

  ngOnInit(): void {
    this.loginUser = localStorage.getItem('merchant_id') || '';
    this.loginUserName = localStorage.getItem('name') || 'Unknown';
    this.watchQueryParamsForChat();
    this.setupSocketConnection();
    this.getAllTabUsers();
  }

  ngOnDestroy(): void {
    this.socketService.disconnect();
  }

  closeNewChatList() {
    this.showNewChatList = false;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectChatType(type: string) {
    this.selectedChatType = type;
    this.isDropdownOpen = false;
    this.newChat(type);
  }

  //search feature
  filterUsers() {
    const term = this.searchTerm?.toLowerCase() || '';
    const users = this.cachedSearchResult || [];
    // Filter users if search term is not empty
    const filteredUsers = term
      ? users.filter((user) => {
          const name = (
            user.name ||
            user.userName ||
            `${user.firstName || ''} ${user.lastName || ''}`
          ).toLowerCase();
          return name.includes(term);
        })
      : users;

    // Assign filtered result to the appropriate tab
    if (this.activeTab === 'People') {
      this.friends = filteredUsers;
    } else if (this.activeTab === 'Ministries') {
      this.ministriesUserList = filteredUsers;
    } else if (this.activeTab === 'all') {
      this.allTabsUserList = filteredUsers;
    }
  }

  newChat(type?: string) {
    this.chatStatus = false;
    // Map UI selection to backend tab param if provided
    const tabParam = type === 'affiliate' ? 'followers' : type === 'ministry' ? 'ministry' : 'newChat';
    this.authService
      .getData(`/user/getUserFriends?role=Merchant&tab=newChat&selectedTab=${tabParam}`)
      .subscribe((res: any) => {
        this.newChatUser = res?.data;
        this.showNewChatList = true;
      });
  }

  scrollToBottom(): void {
    if (this.chatContainer) {
      try {
        this.chatContainer.nativeElement.scrollTo({
          top: this.chatContainer.nativeElement.scrollHeight,
          // behavior: 'smooth', // Smooth scrolling for better UX
        });
      } catch (err) {
        console.error('Error scrolling to bottom:', err);
      }
    }
  }

  getUserFriendsList() {
    this.authService
      .getData(`/user/getUserFriends?role=Merchant&tab=${this.activeTab}`)
      .subscribe((res: any) => {
        // if (this.activeTab === 'People') {
        //   this.friends = res?.data;
        //   this.cachedSearchResult = res?.data;
        // }
        if(this.activeTab === 'Ministries') {
          this.ministriesUserList = res?.data;
          this.cachedSearchResult = res?.data;
        }

        if(this.activeTab === 'followers')
        {
        this.friends = res?.data;
        this.cachedSearchResult = res?.data;
        }
        if(this.activeTab === 'public')
        {
          this.publicTabsUserList=res?.data;
          this.cachedSearchResult = res?.data;

        }

      });
  }

getAllTabUsers() {
  const public$ = this.authService.getData(
    `/user/getUserFriends?role=Merchant&tab=public`
  );

  const followers$ = this.authService.getData(
    `/user/getUserFriends?role=Merchant&tab=followers`
  );

  const ministries$ = this.authService.getData(
    `/user/getUserFriends?role=Merchant&tab=Ministries`
  );

  forkJoin([public$, followers$, ministries$]).subscribe(
    ([publicRes, followersRes, ministriesRes]: any) => {
      const publicUsers = publicRes?.data || [];
      const followers = followersRes?.data || [];
      const ministries = ministriesRes?.data || [];

      const merged = [...publicUsers, ...followers, ...ministries];

      // Deduplicate by ID
      const uniqueMap = new Map();
      for (let user of merged) {
        const id = user._id || user.id;
        const idStr = typeof id === "object" ? id.toString() : String(id);

        if (!uniqueMap.has(idStr)) {
          uniqueMap.set(idStr, user);
        }
      }

      this.allTabsUserList = Array.from(uniqueMap.values());
      this.cachedSearchResult = this.allTabsUserList;
    }
  );
}

  getSelectedTab(tab: any) {
    this.activeTab = tab;
    this.chatStatus = false;
    if (tab == 'followers' || tab == 'Ministries' || tab == 'public') {
      this.getUserFriendsList();
    } else if (tab == 'all') {
      this.getAllTabUsers();
    }
  }

  watchQueryParamsForChat(): void {
    this.route.queryParams.subscribe((params) => {
      const postOwner = params['postOwner'];
      const contactUser = params['contactUser'];
      const chatType = params['chatType'] || 'business'; // optional

      if (postOwner && contactUser) {
        const postData = {
          postOwner,
          contactUser,
          chatType,
        };
        this.postId = params['postId'] || '';
        this.chatType = chatType;
        setTimeout(() => {
          this.getMerchantChat(postData);
        }, 200);
      }
    });
  }

  setupSocketConnection() {
    this.socketService.connect(this.loginUser);
    this.socketService.emit('join', this.loginUser);
    this.socketService.on('chatMessage').subscribe((data: any) => {
      if (this.loginUser === data.receiverId) {
        this.activeMessageSenderId = data.senderId;
      }
      if (data.senderId != this.loginUser) {
        this.chat = [...this.chat, data];
      }
      this.cdr.detectChanges();
      setTimeout(() => this.scrollToBottom(), 0);
    });
  }

  onImageError(event: any) {
    event.target.src = '../../../../assets/person.png';
  }
  removeDuplicates(array: any[], property: string) {
    return array.filter(
      (obj, index, self) =>
        index === self.findIndex((t) => t[property] === obj[property])
    );
  }

  isValidObjectId(id: any): boolean {
    return typeof id === 'string' && /^[0-9a-fA-F]{24}$/.test(id);
  }

  initiateMerchantChat(user: any) {
    const contactUserId = user?._id || user?.id;
    const postOwnerId = this.loginUser;
    this.showNewChatList = false;
    if (
      !this.isValidObjectId(contactUserId) ||
      !this.isValidObjectId(postOwnerId)
    ) {
      this.chatStatus = false;
      this.chat = [];
      return;
    }

    this.newMessage = '';
    this.userName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
    console.log('usernamdsfdsfd', this.userName);
    this.postId = '';
    this.contactUser = contactUserId;
    //this.checkImage(user);
    const query = {
      contactUser: contactUserId,
      postOwner: postOwnerId,
      chatType: 'business',
    };

    // this.router.navigate(['/cross-chat'], { queryParams: query });
    this.getMerchantChat(query);
  }

  getMerchantChat(postData: any) {
    const postOwner = postData?.postOwner;
    const contactUser = postData?.contactUser;

    if (
      !this.isValidObjectId(postOwner) ||
      !this.isValidObjectId(contactUser)
    ) {
      this.chatStatus = false;
      this.chat = [];
      return;
    }

    this.authService
      .getPostMessages(
        `/postChat/getMerchantById?postOwner=${postOwner}&contactUser=${contactUser}`
      )
      .subscribe(
        (res: any) => {
          if (res.code === 200 && res.data) {
            this.chatData = res.data;
            this.chatId = res.data._id;
            this.chat = res.data.message || [];
            this.postChat = [res.data];
            this.userName =
              res.data.contactUser.userName || res.data.contactUser.name;
            this.postUserImage = res.data.contactUser.photo;
            this.postId = res.data.postId || '';
            this.chatStatus = true;
            setTimeout(() => this.scrollToBottom(), 0);
          } else {
            this.chatStatus = false;
            this.chat = [];
          }
        },
        () => {
          this.chatStatus = false;
          this.chat = [];
        }
      );
  }

  sendMessage() {
    if (!this.newMessage.trim() || !this.chatData || !this.contactUser) return;
    const senderId = this.loginUser;
    const contactUser = this.contactUser;
    const postId = this.postId;
    const messageData = {
      message: this.newMessage,
      senderId: senderId,
      receiverId: contactUser,
      markAsRead: false,
      createdAt: new Date().toISOString(),
    };
    this.authService
      .postData('/postChat/sendMessage', {
        postOwner: senderId,
        contactUser: contactUser,
        postId,
        chatType: 'business',
        message: messageData,
      })
      .subscribe(
        (res: any) => {
          if (res.code === 200 && res.data?.message) {
              this.chat = [
              ...this.chat,
              res.data.message[res.data.message.length - 1],
            ];
            this.newMessage = '';
            setTimeout(() => this.scrollToBottom(), 0);
          }
        },
        () => {
          this.newMessage = '';
        }
      );
  }

  getMessageInput(event: any) {
    this.newMessage = event;
  }

  getTime(data: any) {
    return formatAMPM(data);
  }

  setUrl(user: any) {
    if(!user){
      return '../../../../assets/person.png';
    }
    let photo = user?.photo || user;
    if (photo?.includes('http')) return photo;
    if (photo.includes('uploads/')) {
      return `${environment.basePath}${photo}`;
    }
    if (photo)
      return `${environment.basePath}uploads/${photo.split('uploads')[1]}`;
  }

}
